import React from "react";
import instagram from "../Assests/instagram.png";
import facebook from "../Assests/facebook.png";
import youtube from "../Assests/Youtube.png";

const Footer = () => {
  return (
    <footer
      className="mb-0 w-full bg-white text-black py-8 sm:py-10 md:py-12 lg:py-[60px] px-4 sm:px-6 md:px-8 lg:px-[50px] text-center"
      style={{ fontFamily: "Manrope, sans-serif" }}
    >
      {/* Got a Question */}
      <h2 className="text-[#222222] text-3xl sm:text-4xl md:text-5xl lg:text-[60px] font-bold leading-tight lg:leading-[48px] mb-4 sm:mb-5 md:mb-6 lg:mb-[21px]">
        Got a Question?
      </h2>

      <div className="w-full max-w-xs sm:max-w-lg md:max-w-2xl lg:max-w-4xl xl:max-w-6xl mx-auto text-base sm:text-lg md:text-xl lg:text-[21px] leading-normal lg:leading-[32px] text-center self-center mb-6 sm:mb-8 lg:mb-[32px]">
        If you have a question then please give us a call at{" "}
        <a href="tel:+447592239712" className="text-[#DD0101]">
          +44 7592 239712
        </a>
      </div>

      {/* Social Links */}
      <div className="flex justify-center gap-4 sm:gap-6 md:gap-8 lg:gap-10 mb-4 sm:mb-5 md:mb-6 text-[16px]">
        <a
          target="_blank"
          rel="noreferrer"
          href="https://www.instagram.com/alratv"
          className="hover:opacity-80 transition"
        >
          <img
            src={instagram}
            alt="Instagram"
            className="w-6 h-6 sm:w-8 sm:h-8 md:w-[32px] md:h-[32px] object-contain"
          />
        </a>
        <a
          target="_blank"
          rel="noreferrer"
          href="https://www.facebook.com/alratv"
          className="hover:opacity-80 transition"
        >
          <img
            src={facebook}
            alt="Facebook"
            className="w-6 h-6 sm:w-8 sm:h-8 md:w-[32px] md:h-[32px] object-contain"
          />
        </a>
        <a
          target="_blank"
          rel="noreferrer"
          href="https://www.youtube.com/alratv"
          className="hover:opacity-80 transition"
        >
          <img
            src={youtube}
            alt="YouTube"
            className="w-6 h-6 sm:w-8 sm:h-8 md:w-[32px] md:h-[32px] object-contain"
          />
        </a>
      </div>

      {/* Copyright */}
      <p className="text-xs sm:text-sm md:text-[14px] text-[#666666]">
        © ALRA TV / MFI - The Awakening Network
      </p>
    </footer>
  );
};

export default Footer;
